/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useLogout from "../../core/utilities/useLogout";
import "./navbar.style.css";
import orgData from "./organizationData";
import sideMenuScreens from "./sideMenu";
import {
  setIsAdmin,
  setSideMenu,
  setSelectedTitle,
  setSelectedSub,
} from "../../redux/reducers/user.reducer";
import useScreenConfig from "../../pages/workflow/screenConfig/useScreenConfig";
import ApplicantNavBar from "./ApplicantNavBar";
import StudentApplicantNavBar from "./EducationType/StudentApplicantNavBar";
import SideMenu from "./tailwindCss/sideMenu";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import logo from "../../core/assets/images/templeLogo.svg";
import HeaderTailwindComponent from "../tailwindcssComponents/header/HeaderTailwindComponent";
import { BellIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import Hrm from "../../core/assets/images/Humanwrk_final.png";
const drawerWidth = 240;

export default function Navbar({ children }) {
  const { userLogout } = useLogout();
  const { getSideMenu, sideMenuData } = useScreenConfig({
    screenName: "Side Menu",
  });
  const isRtl = false;
  const user = useSelector((state) => state.user.userData);

  const isAdmin = useSelector((state) => state.user.isAdmin);
  const sideMenu = useSelector((state) => state.user.sideMenu);
  const [open, setOpen] = useState(false);
  const [side, setSide] = useState("");
  const [Nbox, setNbox] = useState(false);
  const [sideMenuDetails, setSideMenuDetails] = useState([]);
  const [value, setValue] = useState("2");
  const ref = useRef();
  const dispatch = useDispatch();
  const applicantLoginData = useSelector(
    (state) => state.user.applicantLoginData
  );

  useEffect(() => {
    if (user?.department && user?.role) {
      // if (Object.keys(sideMenu).length === 0) {
      getSideMenu({
        variables: {
          department: user?.department,
          role: user?.role,
          orgId: user?.orgId,
        },
      });
      // }
    }
  }, [user]);
  // useEffect(() => {
  //   if (Object.keys(sideMenu).length === 0 && sideMenuData?.getSideMenu) {
  //     const parsedSideMenu = JSON.parse(sideMenuData.getSideMenu.screens);
  //     dispatch(setSideMenu(parsedSideMenu));
  //   }
  // }, [sideMenuData]);
  useEffect(() => {
    if (sideMenuData?.getSideMenu) {
      const parsedSideMenu = JSON.parse(sideMenuData?.getSideMenu?.screens);
      setSideMenuDetails(parsedSideMenu);
      dispatch(setSideMenu(parsedSideMenu));
    }
  }, [sideMenuData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClickOutside = (e) => {
    if (!ref?.current?.contains(e.target)) {
      setNbox(false);
    }
  };
  const handelNClick = () => {
    setNbox(false);
  };
  const Data = isAdmin ? orgData : sideMenuScreens;
  const navigate = useNavigate();
  const PortalCheck = user?.portalRole;


  const orgLogo = user?.orgDetails?.logo;
  const handleDrawerOpen = () => {
    setOpen((prev) => !prev);
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };
  const handleSideOpen = (id) => {
    setSide((prev) => (prev === id ? "" : id));
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };
  const handleProfileClick = () => {
    const isApplicant = user?.userId?.startsWith("AI");
    if (isApplicant) {
      navigate("/ApplicantProfile");
    } else {
      navigate("/profile");
    }
    handleMenuClose();
  };
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const restricted = () => {
    dispatch(setIsAdmin(false));
  };
  useEffect(() => {
    if (![1, 2].includes(PortalCheck)) {
      restricted(); // Only call restricted if PortalCheck is not 1 or 2
    }
  }, [PortalCheck, dispatch]); // Effect runs when PortalCheck changes

  const handleSelectItemTitle = (label, i) => {
    dispatch(setSelectedTitle(label));
  };
  const handleSelectItemSub = (subLabel, titleLabel) => {
    const data = {
      subLabel: subLabel,
      titleLabel: titleLabel,
    };
    dispatch(setSelectedSub(data));
  };
  const menuId = "primary-search-account-menu";
  const renderMenu = isMenuOpen && (
    <div
      className="absolute right-0 top-12 w-48 bg-white shadow-lg rounded-lg z-50"
      onMouseLeave={handleMenuClose}
    >
      <button
        onClick={handleProfileClick}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <Link
          to="/profile"
          className="w-full block text-blue-600 hover:underline"
        >
          Profile
        </Link>
      </button>
      <button
        onClick={userLogout}
        className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 hover:text-red-800"
      >
        Logout
      </button>
    </div>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = isMobileMenuOpen && (
    <div
      className="absolute right-0 top-12 w-56 bg-white shadow-lg rounded-lg z-50"
      onMouseLeave={handleMobileMenuClose}
    >
      <div className="flex items-center px-4 py-2 hover:bg-gray-100">
        <div className="mr-3">
          <div className="relative">
            <BellIcon className="w-6 h-6 text-gray-700" />
            <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
              0
            </span>
          </div>
        </div>
        <p className="text-sm text-gray-700">Notifications</p>
      </div>
      <button
        onClick={handleProfileMenuOpen}
        className="flex items-center w-full px-4 py-2 hover:bg-gray-100"
      >
        <UserCircleIcon className="w-6 h-6 mr-3 text-gray-700" />
        <p className="text-sm text-gray-700">Profile</p>
      </button>
    </div>
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
  }, [Nbox]);
  return (
    <div className="flex min-h-screen">
      <HeaderTailwindComponent
        handleDrawerOpen={handleDrawerOpen}
        open={open}
        orgLogo={orgLogo}
        user={user}
        handleProfileClick={handleProfileClick}
        userLogout={userLogout}
        PortalCheck={PortalCheck}
      />
      <Dialog open={open} onClose={setOpen} className="z-[60]">
        {/* <div className="fixed inset-0 z-[60]" /> */}
        {/* <div className="fixed inset-0 overflow-hidden "> */}
        {/* <div className="absolute inset-0 overflow-hidden"> */}
        <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full z-[60]">
          <DialogPanel
            transition
            className="pointer-events-auto w-[240px] transform transition duration-500 ease-in-out data-closed:-translate-x-full sm:duration-700 z-[60]"
          >
            <form className="flex h-full flex-col bg-white rounded-tr-[70px]">
              {/* <div className="h-0 flex-1 "> */}
              <div className="flex items-center justify-between pl-[10%] pr-4 h-16">
                <Link to="/">

                  <div className="flex items-center justify-center md:justify-start sm:mt-[2px]">
                    {/* Logo */}
                    <div className="!w-[90px] h-[50px] !-ml-[16px] ">
                      <img
                        src={logo}
                        className="w-full h-full object-contain"
                        alt="Temple Hub Logo"
                      />
                    </div>

                    {/* Name */}
                    {/* <div className="font-bold text-[20px] -ml-[16px] text-slate-800 whitespace-nowrap">
                      Temple <span className="text-red-600">Hub</span>
                    </div> */}
                  </div>
                </Link>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="p-1 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 cursor-pointer"
                  aria-label="Close menu"
                >
                  <ChevronLeftIcon className="h-6 w-6" />
                </button>
              </div>
              <div className="!z-[100] shadow-[0_4px_18px_0_rgba(0,0,0,0.25)] min-h-screen">
                {user?.userId?.startsWith("AI") ? (
                  <ApplicantNavBar />
                ) : user?.userId?.startsWith("SA") ? (
                  <StudentApplicantNavBar />
                ) : (
                  <SideMenu
                    Data={Data}
                    isAdmin={isAdmin}
                    user={user}
                    // sideMenu={sideMenu}
                    sideMenu={sideMenuDetails}
                    setOpen={setOpen}
                    open={open}
                  />
                )}
              </div>
              {/* </div> */}
            </form>
          </DialogPanel>
        </div>
        {/* </div> */}
        {/* </div> */}
      </Dialog>

      {/* Main Content */}
      <div
        ref={ref}
        className={`flex-grow min-h-screen overflow-y-auto transition-all duration-500 ease-in-out pt-16 ${open ? "md:ml-[240px]" : "ml-0"
          }`}
      >
        {children}
      </div>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
